// @flow
import type {Action} from '../actions/modals';

export type State = {
    GUESTS: {
        isOpen: boolean,
        +hasOpened: boolean
    },
    DATES: {
        isOpen: boolean,
        +hasOpened: boolean
    },
    SEARCH: {
        isOpen: boolean,
        +hasOpened: boolean
    },
    FILTERS: {
        isOpen: boolean,
        +hasOpened: boolean
    },
    FILTERS_DATES: {
        isOpen: boolean,
        +hasOpened: boolean
    },
    FILTERS_GUEST: {
        isOpen: boolean,
        +hasOpened: boolean
    },
    PRICE_LABEL: {
        isOpen: boolean,
        +hasOpened: boolean
    }
};

const initialState: State = {
    GUESTS: {
        isOpen: false,
        hasOpened: false
    },
    DATES: {
        isOpen: false,
        hasOpened: false
    },
    SEARCH: {
        isOpen: false,
        hasOpened: false
    },
    FILTERS: {
        isOpen: false,
        hasOpened: false
    },
    FILTERS_DATES: {
        isOpen: false,
        hasOpened: false
    },
    FILTERS_GUEST: {
        isOpen: false,
        hasOpened: false
    },
    PRICE_LABEL: {
        isOpen: false,
        hasOpened: false
    }
};

export default function reducer(
    state: State = initialState,
    action: Action
): State {
    if (action.type === 'MODAL/TOGGLE') {
        const newState = action.payload.isOpen
            ? Object.keys(state).reduce((result, modalName) => {
                  result[modalName] = {
                      isOpen: false,
                      hasOpened: state[modalName].hasOpened
                  };
                  return result;
              }, {})
            : state;

        return {
            ...newState,
            [action.payload.modalName]: {
                isOpen: action.payload.isOpen,
                hasOpened: action.payload.isOpen
                    ? true
                    : state[action.payload.modalName].hasOpened
            }
        };
    }
    return state;
}
